import {Model} from 'backbone';

export default class Totals extends Model.extend({}){}